import React, { useContext, useMemo } from 'react';
import { RelayEnvironmentProvider as DefaultProvider, ReactRelayContext, useRelayEnvironment } from 'react-relay';
import { __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ } from './environment';
export function AtlassianRelayEnvironmentProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DefaultProvider, {
    environment: __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__
  }, children);
}
export var RelayEnvironmentProvider = AtlassianRelayEnvironmentProvider;
export var ConditionalRelayEnvironmentProvider = function ConditionalRelayEnvironmentProvider(_ref2) {
  var children = _ref2.children;
  var isRelayPresent = useContext(ReactRelayContext);
  if (isRelayPresent) {
    return children;
  }
  return /*#__PURE__*/React.createElement(AtlassianRelayEnvironmentProvider, null, children);
};
export function useRelayEnvironmentProvider() {
  var environment = useRelayEnvironment();
  return useMemo(function () {
    return {
      getEnvironment: function getEnvironment() {
        return environment;
      }
    };
  }, [environment]);
}